var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5 mb-base"},[_c('statistics-card-line',{attrs:{"icon":"CheckIcon","statistic":_vm.statistic,"statisticTitle":"Kitting Need Approve","chartData":_vm.series,"type":"area","color":"dark"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }